import { type RoutineFormDraft, routineFormDraftsEqual } from '@littlebird/sdk';

/** True when the draft changes the notification settings and nothing else */
export const onlyNotificationsChanged = (
  draft: RoutineFormDraft,
  initialDraft: RoutineFormDraft
): boolean =>
  !routineFormDraftsEqual(draft, initialDraft) &&
  routineFormDraftsEqual(
    {
      ...draft,
      notificationsEnabled: initialDraft.notificationsEnabled,
      emailNotificationsEnabled: initialDraft.emailNotificationsEnabled,
      mayReachOut: initialDraft.mayReachOut,
    },
    initialDraft
  );
